import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Cep Premium - Teknoloji Ürünleri ve Aksesuarlar',
  description = 'Cep Premium resmi mağazasından powerbank, kulaklık, kablo, çanta ve daha fazlası. Türkiye garantili, hızlı kargo ve güvenli alışveriş.',
  keywords = 'cep premium, powerbank, bluetooth kulaklık, şarj kablosu, telefon aksesuarları, teknoloji ürünleri',
  image = 'https://ceppremium.com/logo.png',
  url = typeof window !== 'undefined' ? window.location.href : '',
  type = 'website',
  productData = null
}) => {
  const siteName = 'Cep Premium';
  const twitterHandle = '@ceppremium';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content={twitterHandle} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Language */}
      <meta httpEquiv="content-language" content="tr" />
      <html lang="tr" />
      
      {/* Mobile Optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
      <meta name="theme-color" content="#DC2626" />
      
      {/* Product Structured Data */}
      {productData && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": productData.name,
            "image": productData.image,
            "description": productData.description,
            "brand": {
              "@type": "Brand",
              "name": "Cep Premium"
            },
            "offers": {
              "@type": "Offer",
              "url": url,
              "priceCurrency": "TRY",
              "price": productData.price,
              "availability": productData.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
              "seller": {
                "@type": "Organization",
                "name": "Cep Premium"
              }
            }
          })}
        </script>
      )}
      
      {/* Organization Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Cep Premium",
          "url": "https://ceppremium.com",
          "logo": "https://ceppremium.com/logo.png",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+90-551-834-88-83",
            "contactType": "customer service",
            "areaServed": "TR",
            "availableLanguage": "Turkish"
          },
          "sameAs": [
            "https://www.instagram.com/ceppremium",
            "https://www.facebook.com/ceppremium"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
